// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import global_ from './components/Global'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import {I18nClient} from './scripts/AllExport'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './../static/fonts/font.css'

// Import our CSS
import './../static/scss/robust.scss'

// Robust's components
// import './../static/js/modules/bootstrap'
// import './../static/js/modules/timeago'
import './../static/js/modules/flickity'
import './../static/js/modules/medium-zoom'
import './../static/js/modules/countdown'

import App from './App'
import router from './router'

// 全画面共通モジュール
require('layui-layer')

Vue.prototype.GLOBAL = global_
Vue.use(ElementUI, { locale })

Vue.use(VueI18n)

const i18n = I18nClient.createI18n()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js